<template>
  <div class="price-card">
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImgBg"
    :loading-icon="$placeImgBg"
     :src="cardData.cover_mobile || cardData.img_url" alt=""></van-image>
    <div class="price-msg">
      <div class="price-name ellipsis_two">{{ cardData.name }}</div>
      <div class="price-des ellipsis_three">{{ cardData.description }}</div>
      <!-- <div class="yingyouPrice" >¥ {{ cardData.price }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: 100%;
  height: 167px;
  margin-bottom: 26px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  .tip{
    position: absolute;
    top:0;
    left:30px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 296px;
  height: 167px;
  border-radius: 12px;
  display: block;
  flex: 0 1 296px;
  margin-right: 26px;
  overflow: hidden;
}

.price-msg {
  flex: 0 1 375px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 375px;
}

.price-name {
  font-size: 28px;
  color: #000;
  font-weight: 500;
  width: 100%;
  margin-bottom: 10px;
}

.price-des {
  font-size: 20px;  
  color: #999;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
}

.yingyouPrice {
  font-size: 32px;
  color: #F08E00;
  font-weight: 500;
}
</style>>
